// Init Swiper for UGC section + video toggle behavior (single playing like ugc.js)
document.addEventListener('DOMContentLoaded', function () {
  // // Swiper init (unchanged)
  // if (typeof Swiper !== 'undefined') {
  //   var ugcSwiper = new Swiper('.s-ugc-swiper', {
  //     loop: false,
  //     slidesPerView: 'auto',
  //     spaceBetween: 20,
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       768: { slidesPerView: 2, spaceBetween: 20 },
  //       1200: { slidesPerView: 4, spaceBetween: 20 },
  //     },
  //   });
  // }
  const swiperUgc = new Swiper('.s-ugc-swiper', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 20,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1200: { spaceBetween: 20 },
    },
  });

  // --- Video toggle behavior ---
  function stopPlayingCurrentVideo(exceptId) {
    var currentPlayingParent = document.querySelector('.s-ugc__item.playing');
    if (currentPlayingParent) {
      currentPlayingParent.classList.remove('playing');
      var currentPlayingVideo = currentPlayingParent.querySelector('video');
      if (currentPlayingVideo && currentPlayingVideo.id !== exceptId) {
        currentPlayingVideo.pause();
      }
    }
  }

  function toggleVideo(video, parentItem) {
    stopPlayingCurrentVideo(video.id);
    if (video.paused) {
      video.play();
      if (parentItem) parentItem.classList.add('playing');
    } else {
      video.pause();
      if (parentItem) parentItem.classList.remove('playing');
    }
  }

  function bindVideoHandlers() {
    var videos = document.querySelectorAll('.s-ugc__item video');
    if (videos.length > 0) {
      videos.forEach(function (video) {
        var parentItem = video.closest('.s-ugc__item');
        // Click on video toggles play/pause
        video.addEventListener('click', function () {
          toggleVideo(video, parentItem);
        });
        // Optional: click on overlay play image toggles as well
        var overlay =
          parentItem && parentItem.querySelector('.s-ugc__item-play');
        if (overlay) {
          overlay.addEventListener('click', function (e) {
            e.preventDefault();
            toggleVideo(video, parentItem);
          });
        }
      });
    } else {
      // If videos not yet in DOM, try again next frame
      requestAnimationFrame(bindVideoHandlers);
    }
  }

  bindVideoHandlers();
});
